import React from 'react'

interface LuraLogoProps {
  width?: number
  height?: number
  className?: string
}

export const LuraLogo: React.FC<LuraLogoProps> = ({
  width = 184,
  height = 64,
  className = ''
}) => {
  return (
    <div className={`flex justify-center ${className}`}>
      <svg width={width} height={height} viewBox="0 0 2194 764">
        <path
          d="M840.2,192h-2v228.7h0c0,31.2-17.3,47.9-49.6,48.3-32.4-.3-50.1-16.9-50.1-48.3v-228.7h-177.9v240c0,7.3.5,14.3,1.4,21.1h-193.4V192h-176.5v368.5h0s375.5,0,375.5,0h0s1.2,0,1.2,0v-80.7c22.6,59.1,92.5,92.3,218.7,92.3s.6,0,.9,0c.3,0,.6,0,.9,0c157.5,0,227.7-51.4,227.7-140.1v-240h-176.8Z"
          fill="var(--color-soft-black)"
        />
        <path
          d="M1863.3,192h-250.2l-119.4,317v-25.8c0-62.4-36-82-97.9-91c51.9-10.5,93.8-38.8,93.8-97.9s-56-102.3-175.8-102.3h-275.7v368.5h176.5v-127.2h32.6c47,0,69.4,12.1,69.4,49.3v32.3c0,25.2,20.4,45.6,45.6,45.6h297.3l17-61.4c15,4.3,36.1,8.6,61.6,8.6s37.1-1.6,61.6-8.6l17,61.4h185.3l-138.8-368.5ZM1258.3,352.1h-43.7v-77.6h43.7c34.4,0,56.8,9.3,56.8,37s-23.1,40.6-56.8,40.6ZM1738.5,424.5c-.1,0-.2,0-.4,0c-.1,0-.2,0-.4,0c-29.3,0-50.8-24.5-39.6-51.5l39.7-97.6l.2.5l.2-.5l39.7,97.6c11.2,27.1-10.3,51.5-39.6,51.5Z"
          fill="var(--color-soft-black)"
        />
      </svg>
    </div>
  )
}

export default LuraLogo
